module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan.dd630eda.svg";